import {
    readNotification,
    countUnreadNotification,
} from '@/services/notification.service';

export const NotificationModule = {
    state: {
        payload: null,
        unread: 0,
    },
    mutations: {
        setUnread(state, unread) {
            state.unread = unread;
        },
        setPayload(state, payload) {
            state.payload = payload;
            state.unread += 1;
        },
    },
    actions: {
        fetchUnread({ commit }) {
            countUnreadNotification().then((res) => {
                commit('setUnread', res.data);
            });
        },
        async readNotification({ state, commit }, id) {
            try {
                const res = await readNotification(id);
                commit('setUnread', state.unread - 1);
                return res;
            } catch (e) {
                console.error(e);
            }
        },
    },
    getters: {
        notificationUnread(state) {
            return state.unread || 0;
        },
        notificationPayload(state) {
            return state.payload;
        },
    },
    namespaced: true,
};
